import Keycloak from 'keycloak-js'
export const ROOT_PATH =  process.env.PUBLIC_URL;
const keycloak = Keycloak(`${ROOT_PATH}/keycloak.json`);

export default keycloak